/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(document).on("turbo:load", function () {
  $("#panels").on(
    "click.edFeedback",
    "button.open-educator-feedback",
    function (e) {
      e.preventDefault()
      return $(this)
        .parents(".panel-response")
        .addClass("active")
        .next(".panel-educator-feedback")
        .addClass("active")
        .find("textarea")
        .focus()
    }
  )

  $("#panels").on(
    "click.edFeedback",
    "button.cancel-educator-feedback",
    function (e) {
      e.preventDefault()
      const $panel = $(this).parents(".panel-educator-feedback")
      if ($panel.find(".feedback-list .feedback").length) {
        $panel.find(".feedback-form").removeClass("active")
        $panel.find(".respond-educator-feedback").addClass("active")
        return $panel.find(".feedback-border").addClass("active")
      } else {
        return $panel
          .removeClass("active")
          .prev(".panel-response")
          .removeClass("active")
      }
    }
  )

  $("#panels").on(
    "click.edFeedback",
    "button.respond-educator-feedback",
    function (e) {
      e.preventDefault()
      const $panel = $(this)
        .removeClass("active")
        .parents(".panel-educator-feedback")
      $panel.find(".feedback-form").addClass("active").find("textarea").focus()
      $panel.find(".feedback-border").removeClass("active")
      return $panel.find(".submit-educator-feedback").removeAttr("disabled")
    }
  )
  // $(@).parents('.jspContainer').scrollTo("#feedback_body")

  return $("#panels").on(
    "click.edFeedback",
    "button.submit-educator-feedback",
    function (e) {
      const form = $(this).parents("form")
      const textarea = form.find("textarea")
      if (!$.trim(textarea.val())) {
        e.preventDefault()
        return textarea.focus()
      }
    }
  )
})
